import React from 'react';

import { IPohodnikRouterItem } from '.';

const ProductsListPage = React.lazy(() => import('@apps/Products/pages/ProductsListPage'));
const ProductOnePage = React.lazy(() => import('@apps/Products/pages/ProductOnePage'));

const productsRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/products',
    component: () => <ProductsListPage />,
    protected: true,
    title: 'Список продуктов',
  },
  {
    path: '/products/:id',
    component: ({
      match: {
        params: { id },
      },
    }) => <ProductOnePage id_product={+id} />,
    protected: true,
    title: 'Страница продукта',
  },
];

export default productsRoutes;
